import React, { Component, Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { OrderDetailEminPay } from './OrderDetailEminPay';
import { CreditCardEminPay } from './CreditCardEminPay';
import {
    getExpensesByMemberNo,
    selectMemberExpenseByMemberNo,
    clearExpensesList
} from "../../../state/ducks/member/index";
import { createPaymentPayFor, selectPayment, selectCurrentPage, changeCurrentPage, getActiveMemberNumber, getPaymentSum, selectPaymentSum, getActiveMemberNoList } from "../../../state/ducks/payment/index"
import $ from 'jquery';
import Modal from '../Modal';
import { createPaymentPages } from '../../../state/ducks/payment/types';

const pageStatus = [createPaymentPages.orderDetail, createPaymentPages.creditCard, createPaymentPages.sms];

export class CreatePaymentOrderEminPay extends Component {

    state = {
        showBankPopup: true,
        page: createPaymentPages.orderDetail,
        payment: {
            orderdetail: {
                memberNo: "0",
                startDate: new Date(),
                aylikTutar: "",
                aylikTutarOndalik: 0,
                installmentCount: "",
                paymentType: 1,
            },
            creditcard: {
                cardHolderName: "",
                cardNumber: "",
                expirationMonth: new Date().getMonth() + 1,
                expirationYear: new Date().getFullYear(),
                cvv: "",
                cardType: "",
                bank: "",
                bankCode: "",
                businessCard: ""
            },
            sms: {
                sms: "",
                gsm: ""
            },
        }
    };
    componentDidMount() {

        

        const { paymentType } = this.props.location.state;

        this.props.changeCurrentPage(createPaymentPages.orderDetail)
        this.props.getMemberNumber();
        this.props.getActiveMemberNo(paymentType);
        $("#aciklama").modal('show');

        if (this.state.page == "sms") {

        }

        this.setState(prevState => ({
            payment: {
                ...prevState.payment,
                orderdetail: {
                    ...prevState.payment.orderdetail,
                    paymentType: paymentType
                }
            }
        }));

    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.page !== this.state.page && this.state.page === "sms") {
            // sadece sms sayfasına geçildiğinde çalışır
            this.setState({ showBankPopup: true }); // tekrar aç
            setTimeout(() => {
                this.setState({ showBankPopup: false });
            }, 4000);
        }
    }
    componentWillReceiveProps(nextProps) {
        var pageName = nextProps.payment.page;
        if (pageName != null && pageName != "") {
            this.setState({ page: pageName });
        }
    }
    changePage = (pageName, clearSmsCode) => {
        var currPage = this.state.page;
        if (pageName == "sms") {
            this.createPaymentPayFor(currPage, pageName);
        }
        else {
            this.props.changeCurrentPage(pageName);
        }

    }
    getExpensesByMemberNo = (memberNo, paymentType) => {

        this.props.getMemberExpense(memberNo, paymentType);
    }
    
    clearExpensesList = () => {

        this.props.clearExpensesList();
    }
    getPaymentSum = (memberNo) => {
        this.props.getPaymentSummary(memberNo)
    }
    createPaymentPayFor = (currPage, pageName) => {
        var data = this.state.payment;
        if (data.orderdetail.startDate instanceof Date) {
            data.orderdetail.startDate = data.orderdetail.startDate.toLocaleDateString("tr-TR");
        }
        this.props.createPaymentOrder(data, currPage, pageName);
    }

    render() {
        const options = {
            decodeEntities: true,
        };

        
        const { paymentType } = this.props.location.state;

        var page = this.state.page;
        const { alert, payment } = this.props;
        const { showBankPopup } = this.state;
        if (page === "sms") {
            return (
                <>
     
                            {showBankPopup ? (
                                <div
                                    style={{
                                      
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        backgroundColor: "rgba(0,0,0,0.6)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        zIndex: 9999
                                    }}
                                >
                                    <div
                                        style={{
                                            background: "#ffffff",
                                            padding: "25px 35px",
                                            borderRadius: "16px",
                                            fontSize: "18px",
                                            fontWeight: "500",
                                            textAlign: "center",
                                            maxWidth: "420px",
                                            boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
                                            border: "3px solid #28a745",   // yeşil çerçeve
                                            color: "#155724",              // koyu yeşil yazı
                                            fontFamily: "Arial, sans-serif",
                                            lineHeight: "1.6"
                                        }}
                                    >
                                        <div
                                            style={{
                                                fontSize: "20px",
                                                fontWeight: "bold",
                                                marginBottom: "10px",
                                                color: "#28a745"
                                            }}
                                        >
                                            ⏳ Lütfen Bekleyin
                                        </div>
                                        <div>
                                            Ekranı kapatmayın veya ayrılmayın, <br />
                                            <strong>bankaya yönlendiriliyorsunuz...</strong>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                            <iframe
                                id="eminPay-iframe"
                                width="100%"
                                height="640"
                                frameBorder="0"
                                srcDoc={payment.response.messages[0]}
                            />
                            )}
                        </>
          
            );
        }
        else {
            return (
                <div className="contanier-fluid">
                    <Modal message={alert?.message} type={alert?.type} />

                    {page == createPaymentPages.orderDetail ? (
                        <OrderDetailEminPay

                            changePage={this.changePage}
                            orderdetail={this.state.payment.orderdetail}
                            getExpense={this.getExpensesByMemberNo}
                            expenses={this.props.expenses}
                            getPaymentSummmary={this.getPaymentSum}
                            payment={this.props.payment}
                            clearExpensesList={this.clearExpensesList}>
                        </OrderDetailEminPay>)
                        : page == createPaymentPages.creditCard ? (
                            <CreditCardEminPay
                                changePage={this.changePage}
                                creditcard={this.state.payment.creditcard}
                                orderdetail={this.state.payment.orderdetail}
                                createPaymentPayFor={this.createPaymentPayFor}>
                            </CreditCardEminPay>)
                            : (<div></div>)
                    }


                    <div className="modal text-center" id="aciklama" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                        <div className="t-modalAreaMailOrder" id="id-modal" style={{ display: "block" }}>
                            {/* Bu kısım animasyon için Hareket eden kısım. */}
                            <div className="t-modalContentMailOrder" id="id-modalTipi" style={(window.innerWidth <= 900) ? { width: "89%" } : { width: "51%" }}>
                                <div
                                    className="t-modalMailOrder"
                                    id="id-modalGenel"
                                    style={{ backgroundColor: "rgb(255, 255, 255)", boxShadow: "3px 3px 3px #939191" }}
                                >
                                    <div className="container-fluid">
                                        {/* Header */}
                                        <div className="row t-modalHeaderMailOrder">
                                            <div
                                                className="col"
                                                id="id-modalHeader"
                                                style={{ color: "rgb(119, 119, 119)" }}
                                            >
                                                TALİMAT GÖNDERİMİ İLE İLGİLİ AÇIKLAMA
                                            </div>
                                            <div className="col-auto t-cursorPointer" data-dismiss="modal">
                                                <i
                                                    className="t-icon-cross"
                                                    id="id-modalHeaderIcon"
                                                    style={{ color: "rgb(119, 119, 119)" }}
                                                />
                                            </div>
                                        </div>
                                        {/* Body */}
                                        <div className="row t-modalBodyMailOrder" style={{ minHeight: 'auto' }}>
                                            <div
                                                className="col-12 "
                                                id="id-modalBody"
                                                style={{ color: "rgb(119, 119, 119)", fontSize: "12pt" }}
                                            >
                                                <strong>
                                                    {paymentType === 1 ? "Kredi kartıyla talimatlar yalnızca “organizasyon ücreti” tutarı kadar girilebilir." : "Kredi kartıyla talimatlar yalnızca “organizasyon ücreti” tutarı kadar girilebilir." }
                                                    
                                                </strong>
                                                <br />
                                                <strong>
                                                    Girdiğiniz ödeme talimatının gerçekleşebilmesi için;
                                                </strong>
                                                <br />
                                                talimat tarihinde, kaydı girilmiş olan kredi kartında yeterli limit
                                                olması durumunda başarılı gerçekleşecektir.

                                                <br />
                                                Tahsilatın başarılı gerçekleşmesi sonrası taksitlere yansıması 1-2
                                                iş günü sürebilmektedir.
                                            </div>
                                        </div>
                                        {/* footer*/}
                                        <div className="row t-modalFooterMailOrder">
                                            <div
                                                className="col-12"
                                                id="id-modalFooter"
                                                style={{ color: "rgb(102, 102, 102)" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        payment: selectPayment(state),
        expenses: selectMemberExpenseByMemberNo(state),
        paymentSumData: selectPaymentSum(state)
    };
}
const mapDispatchToProps = dispatch => ({
    createPaymentOrder: (orderdetail, creditCard) => dispatch(createPaymentPayFor(orderdetail, creditCard)),
    getMemberNumber: () => dispatch(getActiveMemberNumber()),
    getActiveMemberNo: (paymentType) => dispatch(getActiveMemberNoList(paymentType)),
    changeCurrentPage: (page) => dispatch(changeCurrentPage(page)),
    getMemberExpense: (memberNo, paymentType) => dispatch(getExpensesByMemberNo(memberNo, paymentType)),
    getPaymentSummary: (memberNo) => dispatch(getPaymentSum(memberNo)),
    clearExpensesList: () => dispatch(clearExpensesList()),
});
export default connect(mapStateToProps, mapDispatchToProps)(CreatePaymentOrderEminPay);